import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './style/ProductList.css';
import UsePaymentItems from "../Backend/UsePaymentItems";
import useUsersData from '../Auth/AllUsers';
import { API_CONFIG } from './../config'; 
import TopNavbar from '../home/TopNavbar';
import OfferCountdown from './OfferCountdown';
import SubcriptionOfferTime from '../Backend/SubcriptionOfferTime';

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.ALLPAYMENTS}`;

const ProductList = () => {
    const userId = localStorage.getItem('userPhone') || "";
    const { paymentItems, loading } = UsePaymentItems();
    const { subcriptionOffer, subcriptionOfferLoading } = SubcriptionOfferTime()
    const { users } = useUsersData();
    const [selectedItem, setSelectedItem] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const navigate = useNavigate();

    const allOfferTime = subcriptionOffer.find(offer => offer.id === 1);
    const offerTime = allOfferTime?.time;
    const offerPrice = allOfferTime?.offerPrice;

    const expiryTime = offerTime;

    const savePaymentDetails = async (purchaseToken, itemToBuy) => {
        const matchUser = users?.find(user => user.phone === userId);
        const userName = matchUser?.name || "No";
        const email = matchUser?.email || "No";

        const payload = {
            name: userName,
            phone: userId,
            email: email,
            amount: itemToBuy?.price || "299",
            buyed: itemToBuy?.type || "No",
            year: String(itemToBuy?.id || '1'),
            paymentId: purchaseToken,
            coupon: "No"
        };

        const response = await fetch(CREATE_USER_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
            mode: 'cors'
        });

        const responseText = await response.text();
        console.log('🔵 Raw Backend Response:', responseText);

        let data;
        try {
            data = JSON.parse(responseText);
        } catch (parseError) {
            throw new Error('Server returned non-JSON response');
        }

        if (!response.ok || !data.success) {
            throw new Error(data.message || `API failed with status ${response.status}`);
        }

        return data;
    };

    // Direct Google Play Billing launch method
    const handleDirectPayment = async () => {
        if (!userId) {
            alert('Phone number / User ID is required.');
            return;
        }

        if (!selectedItem) {
            alert('Please select an item first.');
            return;
        }

        if (!('getDigitalGoodsService' in window)) {
            alert('Google Play Billing is only available inside our official Android App.');
            return;
        }

        setIsProcessing(true);
        const skuId = String(selectedItem.id);
        const amount = String(selectedItem.price || "299");
        const yearsCount = parseInt(skuId, 10) || 1;

        try {
            // 1. Connect to Play Billing Service
            const service = await window.getDigitalGoodsService('https://play.google.com/billing');

            // 2. Clear any pending/stuck tokens on device
            if (service && typeof service.listPurchases === 'function') {
                try {
                    const existingPurchases = await service.listPurchases();
                    for (const p of existingPurchases) {
                        if (typeof service.consume === 'function' && p.purchaseToken) {
                            try { await service.consume(p.purchaseToken); } catch (_) { }
                        }
                    }
                } catch (e) {
                    console.warn('⚠️ listPurchases skipped:', e);
                }
            }

            // 3. Request Google Play Payment Sheet
            const paymentMethods = [{
                supportedMethods: 'https://play.google.com/billing',
                data: { sku: skuId }
            }];

            const paymentDetails = {
                total: {
                    label: selectedItem.name || `Subscription (${yearsCount} Year${yearsCount > 1 ? 's' : ''})`,
                    amount: { currency: 'INR', value: amount }
                }
            };

            const request = new PaymentRequest(paymentMethods, paymentDetails);
            const paymentResponse = await request.show();

            const purchaseToken = paymentResponse.details?.token || paymentResponse.details?.purchaseToken;
            console.log('🟡 Purchase Token from Play Store:', purchaseToken);

            if (!purchaseToken) {
                try { await paymentResponse.complete('fail'); } catch (_) { }
                alert('Payment failed: No purchase token returned from Play Store.');
                setIsProcessing(false);
                return;
            }

            // 4. Client-side Consume attempt (Best effort)
            if (service && typeof service.consume === 'function') {
                try {
                    await service.consume(purchaseToken);
                    console.log('🟢 Consumed via client service');
                } catch (consumeErr) {
                    console.warn('⚠️ Client-side consume failed:', consumeErr);
                }
            }

            // 5. Acknowledge on Backend
            try {
                await savePaymentDetails(purchaseToken, selectedItem);
                console.log('🟢 Purchase saved & acknowledged by backend successfully.');

                try {
                    await paymentResponse.complete('success');
                } catch (compErr) {
                    console.warn('⚠️ Payment complete warning:', compErr);
                }

                setIsProcessing(false);
                localStorage.setItem('userPayment', userId);
                navigate("/payment-success");
            } catch (dbError) {
                console.error('🔴 Acknowledgment/Save failed:', dbError);
                try { await paymentResponse.complete('fail'); } catch (_) { }
                alert('Payment acknowledgment failed: ' + dbError.message);
                setIsProcessing(false);
            }

        } catch (error) {
            console.error('🔴 Google Play Billing Flow Error:', error);
            if (error.name !== 'AbortError') {
                alert(`Billing Error: ${error.message || 'Payment canceled or failed.'}`);
            }
            setIsProcessing(false);
        }
    };




    return (
        <div className="product-container">
            <TopNavbar name="Select the item" />
            <h2 className="section-title">Select an Item to Proceed</h2>

            <div className="product-grid">

                <Link
                    to="https://play.google.com/store/apps/details?id=com.mystudyplace.neetmocktest"
                    style={{ textDecoration: "none" }}
                    target="_blank"
                >
                    <div className="product-card" style={{ background: "#ffd270" }}>
                        <div className="card-header">
                            <p style={{ color: "green" }}>
                                ⚠️ If the payment page does not open.
                            </p>
                        </div>

                        <div className="card-footer">
                            <span
                                className="validity"
                                style={{
                                    background: "blue",
                                    color: "white",
                                    padding: "10px"
                                }}
                            >
                                Update the app from Play Store.
                            </span>
                        </div>
                    </div>
                </Link>

                <div className={`product-card`} style={{ background: "#8affbf" }}>
                    <div className="card-header">
                        <p>If you face any problem or have any query regarding your payment, please email us at:</p>
                        <br></br>
                        <a href="mailto:payments@mystudyplace.online?subject=NEET%20Prep%20Payment%20Issue" className="email-button" >
                            payments@mystudyplace.online
                        </a>
                    </div>
                </div>



                {(!paymentItems || paymentItems.length === 0 || loading) ? (<>
                    <div className="product-container">
                        <p className="loading-text">Loading premium items...</p>
                    </div>
                </>) : (<></>)}


                {paymentItems.slice().reverse().map((item) => {
                    const itemId = item.id;
                    const isSelected = selectedItem?.id === itemId;

                    return (
                        <div
                            key={itemId}
                            className={`product-card ${isSelected ? 'selected' : ''}`}
                            onClick={() => setSelectedItem(item)}
                        >
                            {/* Top Layout Block */}
                            <div className="card-header same-line-item">
                                <h4>{item.name || "Premium Plan"} </h4>
                                <p style={{ fontSize: '15px', float: 'right', color: 'red' }}> <OfferCountdown targetDate={expiryTime} /> </p>
                            </div> <br></br>

                            <div className="card-body-row">
                                <p className="same-line-item">
                                    <del style={{ color: "red", fontSize: "16px" }}>
                                        <p style={{ color: "orange" }}>₹{item.price * offerPrice}</p>
                                    </del>

                                    <span style={{ fontSize: "18px", color: "green", marginLeft: "8px" }}>
                                        ₹{item.price}
                                    </span>
                                </p>
                                <p style={{ color: "orange" }}>Limited-Time Offer</p>

                                <div className="radio-wrapper">

                                    <input
                                        type="radio"
                                        name="product-selection"
                                        checked={isSelected}
                                        onChange={() => setSelectedItem(item)}
                                        style={{
                                            width: "30px",
                                            height: "30px",
                                            cursor: "pointer"
                                        }}
                                    />
                                    <p style={{ fontSize: "13px" }} className="highlight-text">Select</p>
                                </div>

                            </div>



                            <div className="same-line-item">
                                <p style={{ paddingBottom: "10px", fontSize: "15px" }}>Only ₹{item.price}</p>
                                <p style={{ fontSize: "12px" }}>{item.about}</p>

                            </div>


                            <div className="card-footer">
                                <p className="offer-box" style={{ fontSize: "14px", paddingBottom: "17px", marginBottom: "10px" }}> Purchase now before the price returns to the original price of ₹{item.price * offerPrice}.

                                    <p style={{ fontSize: '12px', float: 'right', color: 'red' }}> <OfferCountdown targetDate={expiryTime} /> </p>

                                </p>

                                <hr></hr>
                                <p style={{ fontSize: "12px", color: "green" }}> <strong >Access all of: </strong>📋Mock Tests, 📅PYQs, ☀️DPP,  👑Formulas, 🎴Flashcards, 🧠Mind Maps, 📕Topper Notes & more.</p>
                                <hr></hr>
                                <span className="validity">Validity: {item.valid}</span>

                            </div>

                        </div>
                    );
                })}
            </div>

            <div className='payment-checkout-button'>


                {userId ? (
                    <>
                        {selectedItem ? (
                            <>
                                <div className="checkout-section">
                                    <button
                                        onClick={handleDirectPayment}
                                        disabled={isProcessing}
                                        className="link checkout-btn"
                                        style={{ width: '100%', cursor: isProcessing ? 'not-allowed' : 'pointer', border: 'none' }}
                                    >
                                        <p className="highlight-text">
                                            {isProcessing
                                                ? 'Connecting to Google Play...'
                                                : <>Process to Pay : <strong style={{ color: "orange" }} > ₹{selectedItem.price}</strong> ➔</>}
                                        </p>
                                    </button>
                                </div>
                            </>
                        ) : (
                            <div className="link checkout-btn">
                                <p className="highlight-text">Please select an item.</p>
                            </div>
                        )}
                    </>
                ) : (
                    <>
                        <Link to="/register-before-payment" className="link checkout-btn">
                            <p className="highlight-text">Create account before payment.</p>
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProductList;